{% block rz_technik_feld %}
<div class="rz-technik-feld">
    <div v-if="zeilen.length" class="rz-technik-feld__kopf">
        <span>Bezeichnung</span>
        <span>Wert</span>
        <span></span>
    </div>

    <div v-for="(zeile, index) in zeilen" :key="index" class="rz-technik-feld__zeile">
        <input type="text"
               class="rz-technik-feld__eingabe"
               :value="zeile.label"
               :disabled="disabled"
               placeholder="z. B. Akku"
               @input="aendere(index, 'label', $event.target.value)">
        <input type="text"
               class="rz-technik-feld__eingabe"
               :value="zeile.value"
               :disabled="disabled"
               placeholder="z. B. 1.500 mAh"
               @input="aendere(index, 'value', $event.target.value)">
        <button type="button" class="rz-technik-feld__weg" :disabled="disabled" title="Zeile entfernen" @click="entferne(index)">×</button>
    </div>

    <div class="rz-technik-feld__aktionen">
        <button type="button" class="rz-technik-feld__neu" :disabled="disabled" @click="hinzu(null)">Zeile hinzufügen</button>

        <template v-for="b in bekannt">
            <button v-if="nochNichtVergeben(b)"
                    :key="b.key"
                    type="button"
                    class="rz-technik-feld__vorschlag"
                    :disabled="disabled"
                    @click="hinzu(b)">+ {{ b.label }}</button>
        </template>
    </div>
</div>
{% endblock %}
